type AllTasksCompleteListener = () => void;

let blockCount = 0;
const allTasksCompleteListeners = new Set<AllTasksCompleteListener>();

const notifyWhenAllTasksComplete = (wasBlocked: boolean) => {
  if (wasBlocked && blockCount === 0) {
    allTasksCompleteListeners.forEach((listener) => listener());
  }
};

export const inactivityBlock = {
  block(): void {
    blockCount += 1;
  },
  unblock(): void {
    const wasBlocked = blockCount > 0;
    blockCount = Math.max(0, blockCount - 1);
    notifyWhenAllTasksComplete(wasBlocked);
  },
  isBlocked(): boolean {
    return blockCount > 0;
  },
  onAllTasksComplete(listener: AllTasksCompleteListener): () => void {
    allTasksCompleteListeners.add(listener);

    return () => {
      allTasksCompleteListeners.delete(listener);
    };
  },
};
